import React, { useReducer } from "react";
// import { connect } from 'react-redux';

import "bootstrap/dist/css/bootstrap.min.css";
import "video.js/dist/video-js.min.css";
import "./App.css";

import SearchForm from "./components/SearchForm";
import SearchResults from "./components/SearchResults";
import JobDetails from "./components/JobDetails";
import SkillDetails from "./components/SkillDetails";
import selectedReducer from "./reducers";

import * as jobs_data from "./data/job.json";
import * as clusters_data from "./data/cluster_def.json";

import logo from "./images/ACT_WorkKeys_Color_Digital.svg";

const initialState = {
  jobTitle: "",
  careerCluster: "",
  jobDescription: "",
  isGreen: 0,
  isBright: 0,
  am: "",
  wd: "",
  gl: "",
  ri: "",
  li: "",
  at: "",
  bw: "",
  wo: "",
  searchtype: 1,
  showSkillLevels: false,
  selectedIndex: null,
  selectedSkill: null,
  videoPlayerVisible: false,
  jobs: jobs_data.default,
  filteredJobs: jobs_data.default,
};

function App() {
  const [state, dispatch] = useReducer(selectedReducer, initialState);
  // const reducer = useReducer(rootReducer, initialState);
  // console.log(state);

  return (
    <div className="App">
      <header className="container-fluid left-anchor">
        <div className="col-sm">
          <div className="row align-items-center">
            <a href="https://act.org">
              <img src={logo} alt="ACT WorkKeys logo" />
            </a>
            <h1 style={{ fontSize: "24px", fontWeight: "bold", margin: "0 0 0 16px", color: "#002d61" }}>
              Occupational Profiles
            </h1>
          </div>
        </div>
      </header>
      <div className="container-fluid profile-search left-anchor px-0">
        <div className="row">
          <div className="col-md-8 pr-0 pb-3">
            <SearchForm
              {...state}
              clusters={clusters_data.default}
              dispatch={dispatch}
            />
            <SearchResults
              jobs={state.filteredJobs}
              selectedIndex={state.selectedIndex}
              clusters={clusters_data.default}
              dispatch={dispatch}
            />
          </div>
          <div className="col col-md-4 detail-pane">
            <JobDetails
              job={state.selectedJob}
              selectedIndex={state.selectedIndex}
              videoPlayerVisible={state.videoPlayerVisible}
              clusters={clusters_data.default}
              dispatch={dispatch}
            />
            <SkillDetails
              selectedSkill={state.selectedSkill}
              dispatch={dispatch}
            />
          </div>
        </div>

        <footer className="fixed-bottom text-center">
          <div className="container">
            <div className="row">
              <div className="col px-0">
                &copy; {new Date().getFullYear()} by ACT, Inc.
              </div>
              <div className="col px-0">
                <a href="https://www.act.org/content/act/en/terms-of-use.html">
                  Terms of Use
                </a>
              </div>
              <div className="col px-0">
                <a href="https://www.act.org/content/act/en/privacy-policy.html">
                  Privacy Policy
                </a>
              </div>
              <div className="col px-0">
                <a href="http://www.act.org/content/act/en/products-and-services/workkeys-for-educators.html">
                  Workkeys
                </a>
              </div>
              <div className="col px-0">
                <a href="https://www.act.org/content/act/en/products-and-services/workkeys-for-workforce-developers/job-profiling.html">
                  Job Profiles
                </a>
              </div>
            </div>
          </div>
        </footer>
      </div>
    </div>
  );
}

export default App;
